module.exports = __webpack_public_path__ + "img/bin.22273111.svg";